// extracted by mini-css-extract-plugin
export default {"wrapper":"K4-z","play":"L4-z"};